export default "__VITE_ASSET__B1NL_1ko__"